import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsightsMonitorService } from '@services/monitor/application-insights-monitor.service';
import { ErrorHandler } from '@angular/core';

/**
 * Provides the Application Insights service and custom error handler.
 * - Registers `ApplicationInsightsMonitorService` for tracking telemetry.
 * - Overrides Angular's default `ErrorHandler` with Application Insights error handling.
 *
 * @example
 * ```typescript
 * bootstrapApplication(AppComponent, {
 *   providers: [
 *     ...ProvideApplicationInsightsService()
 *   ]
 * });
 * ```
 */
export const ProvideApplicationInsights = () => {
  return [
    ApplicationInsightsMonitorService,
    {
      provide: ErrorHandler,
      useClass: ApplicationinsightsAngularpluginErrorService,
    },
  ];
};
